import React from 'react';
import './ui.css';

export function YTable({ className = '', striped = true, hover = true, children, ...rest }) {
  const classes = [
    'table',
    striped ? 'table-striped' : '',
    hover ? 'table-hover' : '',
    className
  ].filter(Boolean).join(' ');
  return (
    <div className="y-table-wrap">
      <table className={classes} {...rest}>
        {children}
      </table>
    </div>
  );
}
